import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				borderRadius: 6,
				position: "relative",
				marginTop: 10,
				display: "flex",
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				"& > img": {
					width: 100,
					height: 124
				}
			},
			rootLogo: {
				borderRadius: "6px 0px 0px 6px",
				"& > img": {
					width: 100,
					height: 124
				}
			},
			bodyText: {
				padding: 16,
				width: "100%"
			},
			productName: {
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				overflow: "hidden",
				display: "inline-block",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				width: 200
			},
			pointProduct: {
				width: "100%",
				display: "flex",
				marginTop: 20,
				alignItems: "center"
			},
			title: {
				fontSize: 14,
				color: theme.palette.grey[50]
			},
			weight500: {
				fontWeight: 500
			},
			point: {
				color: theme.palette.error.main,
				fontSize: 16,
				fontWeight: 500,
				width: 90,
				marginRight: 3,
				borderRight: `0.75px solid ${theme.palette.grey[800]}`
			},
			btnDefault: {
				position: "absolute",
				bottom: 0,
				right: 0,
				borderRadius: "20px 0px 6px ",
				background: theme.palette.secondary.main,
				color: theme.palette.common.white,
				fontSize: 14,
				textTransform: "inherit",
				padding: 5,
				height: 34,
				width: 100,
				"&:hover": {
					background: `${theme.palette.secondary.dark} !important`
				}
			},
			disabledConfirm: {
				background: `${theme.palette.secondary.dark}`,
				color: `${theme.palette.common.white} !important`
			},
			dialogHeader: {
				marginTop: 5,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`
			},
			titleHeader: {
				color: theme.palette.grey[50],
				fontSize: 18
			},
			titleProgram: {
				color: theme.palette.primary.contrastText,
				fontSize: 20,
				fontWeight: 500,
				padding: "10px 65px"
			},
			textListProduct: {
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				fontWeight: 500
			},
			subTextListProduct: {
				display: "list-item",
				marginLeft: 15,
				fontSize: 14,
				color: theme.palette.grey[50],
				marginTop: 10,
				marginBottom: 10,
				"& > span": {
					fontWeight: 500
				}
			},
			listProducts: {
				paddingBottom: 135,
				height: 245,
				overflowY: "scroll"
			},
			products: {
				borderBottom: "1px dashed #E9E8E8"
			},
			wrapperProduct: {
				background: theme.palette.common.white,
				borderRadius: 8,
				padding: 10,
				marginTop: 10,
				display: "flex"
			},
			imageProduct: {
				width: 68,
				height: 68,
				"& > img": {
					width: 68,
					height: 68,
					objectFit: "contain"
				}
			},
			infoProduct: {
				display: "flex",
				flexDirection: "column",
				width: "calc(100% - 68px)",
				justifyContent: "space-between",
				paddingLeft: 10
			},
			quantityGift: {
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center"
			},
			quantity: {
				fontSize: 14,
				color: theme.palette.grey[50]
			},
			wrapperFooter: {
				position: "absolute",
				bottom: 0,
				width: "100%",
				background: theme.palette.common.white
			},
			productsFooter: {
				borderBottom: `1px dashed ${theme.palette.grey[800]}`,
				padding: "10px 0px"
			},
			wrapperTitle: {
				display: "flex",
				justifyContent: "space-between",
				marginBottom: 5
			},
			titleFooter: {
				fontSize: 15,
				color: theme.palette.primary.contrastText
			},
			wrapperError: {
				minHeight: 30,
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			},
			textError: {
				color: theme.palette.error.main,
				fontSize: 14,
				fontStyle: "italic"
			},
			btnConfirm: {
				background: theme.palette.secondary.main,
				color: theme.palette.common.white,
				fontSize: 14,
				textTransform: "inherit",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: 36,
				width: "100%",
				borderRadius: 6,
				borderColor: theme.palette.grey["A100"],
				cursor: "pointer",
				"&:hover": {
					background: `${theme.palette.secondary.dark}`
				}
			},
			btnConfirmDisabled: {
				cursor: "auto !important",
				background: `${theme.palette.secondary.dark} !important`
			},
			btnCancel: {
				background: theme.palette.grey["A100"],
				color: theme.palette.secondary.main,
				border: `1px solid ${theme.palette.secondary.main}`,
				fontSize: 14,
				textTransform: "inherit",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: 34,
				width: "100%",
				borderRadius: 6,
				cursor: "pointer",
				"&:hover": {
					background: `${theme.palette.secondary.dark} !important`
				}
			}
		}),
	{
		name: "CardGiftItem",
		index: 1
	}
);

export default useStyles;
